// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"76d631c2","161":"b348c873"}[chunkId] + ".chunk.js";
};